import { render } from "./DocumentPreviewModal.vue?vue&type=template&id=add5bee6&scoped=true&ts=true"
import script from "./DocumentPreviewModal.vue?vue&type=script&lang=ts"
export * from "./DocumentPreviewModal.vue?vue&type=script&lang=ts"

import "./DocumentPreviewModal.vue?vue&type=style&index=0&id=add5bee6&lang=scss&scoped=true"
import "./DocumentPreviewModal.vue?vue&type=style&index=1&id=add5bee6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add5bee6"]])

export default __exports__